import React from "react";
import "./Services.css";
import { FaFire, FaTree, FaHandHoldingHeart } from "react-icons/fa";

const Services = () => {
  const serviceData = [
    {
      title: "Cremation",
      description:
        "We provide respectful cremation services to ensure a dignified farewell for your beloved pet. Choose from private, communal, or witnessed cremation options.",
      icon: <FaFire />,
      details:
        "Cremation is a peaceful way to honor your pet’s memory. With our private cremation, your pet is cremated individually, and the ashes are returned to you. Communal cremation involves multiple pets, and ashes are scattered in a serene memorial garden.",
    },

    {
      title: "Memory Tree",
      description:
        "Honor your pet’s memory by planting their ashes with a tree, creating a living tribute that grows in their remembrance.",
      icon: <FaTree />,
      details:
        "The Memory Tree service allows you to turn ashes into a growing tree in your backyard or a designated memorial forest. This symbolizes life, renewal, and eternal love.",
    },
    {
      title: "Burial",
      description:
        "Traditional and peaceful pet burial services, ensuring your pet rests in a serene and respectful environment.",
      icon: <FaHandHoldingHeart />,
      details:
        "We provide pet burial services in private or communal pet cemeteries. Our burial plots come with customizable headstones, allowing you to engrave their name and a heartfelt message.",
    },

  ];
  const servicesData = [
    {
      title: "Cremation",
      description: "Dignified farewell with respectful cremation services.",
      image: "images/1-2 (1).jpg",
    },

    {
      title: "Memory Tree",
      description: "Plant ashes as a tree to keep memories alive forever.",
      image: "images/images.jpg",
    },
    {
      title: "Burial",
      description: "Traditional and peaceful pet burial services.",
      image: "images/b.jpg",
    },
  ];

  return (
    <div className="srtech-services-wrapper">
      <div className="srtech-services-section">
      <h1 className="srtech-section-title">Our Services</h1>
      <div className="srtech-services-container">
        {servicesData.map((service, index) => (
          <div className="srtech-service-card" key={index}>
            <img src={service.image} alt={service.title} className="srtech-service-image" />
            <h2 className="srtech-service-title">{service.title}</h2>
            <p className="srtech-service-description">{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  

      {/* Detailed Explanations */}
      <div className="srtech-service-details">
        {serviceData.map((service, index) => (
          <div key={index} className="srtech-service-detail-card">
            <h3 className="srtech-detail-title">{service.title}</h3>
            <p className="srtech-detail-text">{service.details}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
